import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function CardPreparedBy() {
  return (
    <Card className="tw:bg-transparent" size="sm">
      <CardHeader>
        <CardTitle>9. Prepared By</CardTitle>
      </CardHeader>
      <CardContent>
        <p>Awaiting signature</p>
      </CardContent>
    </Card>
  );
}
